<div class="relative">
  <button
    type="button"
    (click)="toggle()"
    class="relative flex h-10 w-10 items-center justify-center rounded-full bg-alpha-blue-10"
  >
    <app-icon
      icon="notification"
      fill="#1990FF"
      height="20px"
      class="block h-5 w-5"
    />

    <span
      *ngIf="unreadCount$ | async as count"
      class="absolute -right-1 -top-1 flex h-5 min-w-5 items-center justify-center rounded-full bg-alpha-red px-1 text-xs font-medium text-white"
    >
      {{ count }}
    </span>
  </button>

  <ng-container *ngIf="isOpen">
    <div
      aria-disabled="true"
      (keydown)="close()"
      (click)="close()"
      class="fixed bottom-0 left-0 right-0 top-0 z-40"
    ></div>

    <div
      class="absolute bottom-full left-0 z-50 mb-3 w-96 overflow-hidden rounded-2xl bg-white shadow-lg ring-1 ring-black/5"
    >
      <div class="flex items-center justify-between gap-4 px-5 pb-4 pt-5">
        <h3 class="text-base font-semibold text-black" i18n>Notifications</h3>

        <button
          *ngIf="unreadCount$ | async"
          type="button"
          (click)="markAllRead()"
          class="flex-none text-xs font-medium text-alpha-blue transition-colors hover:text-black"
          i18n
        >
          Mark all as read
        </button>
      </div>

      <div class="flex gap-1 px-5 pb-4">
        <button
          *ngFor="let option of filterOptions"
          type="button"
          (click)="setFilter(option.value)"
          class="rounded-full px-3 py-1.5 text-xs font-medium transition-colors"
          [ngClass]="
            (filter$ | async) === option.value
              ? 'bg-alpha-blue-10 text-alpha-blue'
              : 'bg-gray-50 text-gray-600 hover:bg-gray-100'
          "
          i18n
        >
          {{ option.label }}
        </button>
      </div>

      <div class="border-t border-gray-100">
        <ng-container *ngIf="items$ | async as allItems">
          <ng-container *ngIf="filteredItems$ | async as items">
            <ul
              *ngIf="items.length; else empty"
              class="flex max-h-96 flex-col gap-1 overflow-y-auto p-2"
            >
              <li *ngFor="let item of items">
                <button
                  type="button"
                  (click)="viewNotification(item)"
                  class="flex w-full items-start gap-3 rounded-xl p-3 text-left transition-colors hover:brightness-95 active:brightness-90"
                  [ngClass]="{ 'bg-alpha-blue-10': !item.readAt }"
                >
                  <span
                    class="mt-1.5 h-2 w-2 flex-none rounded-full"
                    [ngClass]="
                      !item.readAt ? 'bg-alpha-blue' : 'bg-transparent'
                    "
                  ></span>

                  <div class="min-w-0 flex-1">
                    <p
                      class="text-sm leading-snug"
                      [ngClass]="
                        !item.readAt
                          ? 'font-semibold text-black'
                          : 'text-gray-600'
                      "
                    >
                      {{ item.content }}
                    </p>
                    <p class="mt-1 text-xs text-gray-500">
                      {{ item.createdAt * 1000 | date: 'dd/MM/yyyy HH:mm' }}
                    </p>
                  </div>
                </button>
              </li>
            </ul>

            <ng-template #empty>
              <div class="px-5 py-10 text-center">
                <p
                  *ngIf="allItems.length === 0; else noFilterResults"
                  class="text-sm text-gray-500"
                  i18n
                >
                  No notifications yet.
                </p>

                <ng-template #noFilterResults>
                  <p
                    *ngIf="(filter$ | async) === 'UNREAD'"
                    class="text-sm text-gray-500"
                    i18n
                  >
                    No unread notifications.
                  </p>
                  <p
                    *ngIf="(filter$ | async) === 'READ'"
                    class="text-sm text-gray-500"
                    i18n
                  >
                    No read notifications.
                  </p>
                </ng-template>
              </div>
            </ng-template>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </ng-container>
</div>
